import React, { useContext, useState } from 'react';
import { UIContext } from './UIContext';

/* eslint-disable @typescript-eslint/no-empty-function */
const FilterContext = React.createContext({
  paginationModel: { page: 0, pageSize: 10 },
  setPaginationModel: (_newPaginationModel: { page: number; pageSize: number }) => {},
});
/* eslint-enable @typescript-eslint/no-empty-function */

const FilterContextProvider = ({
  children,
  pageSize,
}: {
  children: JSX.Element;
  pageSize?: number;
}) => {
  const { isMobile } = useContext(UIContext);

  const getDefaultPageSize = () => {
    if (pageSize) {
      return pageSize;
    }

    if (isMobile) {
      return 5;
    }

    return 10;
  };

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: getDefaultPageSize(),
  });

  const changePaginationModel = (newPaginationModel: { page: number; pageSize: number }) => {
    let pageToSet = newPaginationModel.page;
    if (Number.isNaN(pageToSet)) {
      pageToSet = 0;
    }
    setPaginationModel({ page: pageToSet, pageSize: newPaginationModel.pageSize });
  };

  const contextValue = {
    paginationModel,
    setPaginationModel: changePaginationModel,
  };

  return <FilterContext.Provider value={contextValue}>{children}</FilterContext.Provider>;
};

export { FilterContext, FilterContextProvider };
